package component.product

import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import feature.productCategory.handler.ProductCategoryHandler
import feature.productCategory.model.ProductCategory
import feature.productCategory.viewModel.ProductCategoryViewModel

@Composable
fun CategoriesList(
    viewModel: ProductCategoryViewModel,
    onClick: (ProductCategory) -> Unit,
) {
    val allCategories = viewModel.allCategory.collectAsState()
    LaunchedEffect(key1 = Unit) {
        viewModel.fetchAllProductCategory()
    }
    LazyRow {
        items(count = allCategories.value.count()) { index ->
            ProductCategoryCard(category = allCategories.value[index], onClick = {
                ProductCategoryHandler.shared().repository.selectedCategoryForNavigation = it
                onClick(it)
            })
        }
    }

}
